import React, { useState, useEffect, useRef } from "react";
import "../../../styles/utils/modal/FinalModal.scss";
import { createPortal } from "react-dom";
import {
  callFalaiAPIforBackground,
  callChatGPTAPIforTitle,
  callChatGPTAPIforBookcover,
  saveCompletedBook,
  getFalaiBackgroundStatus,
} from "../../../api/StoryAPI";
import Loading from "../loading/Loading";
import CompleteModal from "../../creating/modal/CompleteModal";
import { useParams } from "react-router-dom";
import ErrorModal from "./ErrorModal";
import useAppTranslation from "../../../hooks/useAppTranslation";

const FINAL_MODAL_NAMESPACE = "components/utils/finalModal";

const FinalModal = ({ contentList, story_id, branchNum, jobId, onClose }) => {
  const { t } = useAppTranslation(FINAL_MODAL_NAMESPACE);
  const { selectedBookId } = useParams();
  const USER_ID = localStorage.getItem("userID");

  const [errorInfo, setErrorInfo] = useState(null);
  const [bookTitle, setbookTitle] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [generateEnd, setGenerateEnd] = useState(false);
  const [loadingTitle, setLoadingTitle] = useState("");
  const [loadingFlag, setLoadingFlag] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [showCoverButton, setshowCoverButton] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [titleMade, setTitleMade] = useState(false);
  const [coverMade, setCoverMade] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [showNameInput, setShowNameInput] = useState(false);
  const [showNameModal, setShowNameModal] = useState(false);

  const [savedBookId, setSavedBookId] = useState(null);

  const audioRef = useRef(null);
  const isMountedRef = useRef(true);
  const isCoverGeneratingRef = useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const isSavingRef = useRef(false);

  const controlLoading = (on) => {
    if (on) {
      setGenerateEnd(false);
      setShowLoading(true);
    } else {
      setGenerateEnd(true);
      setShowLoading(false);
    }
  };

  const handleGoBack = () => {
    onClose();
  };

  useEffect(() => {
    console.log(`bookTitle.length: ${bookTitle.length}`);
    console.log(`backgroundImage.length: ${backgroundImage.length}`);
    if (bookTitle.length != 0 && backgroundImage.length != 0) {
      setIsContentVisible(false);
      setIsButtonEnabled(true);
    }
  }, [bookTitle, backgroundImage]);

  const handleMakeTitle = async () => {
    setLoadingTitle(t("loading.makeTitle"));
    setLoadingFlag("title");
    controlLoading(true);

    const isAudioInDOM = () =>
      audioRef.current && document.body.contains(audioRef.current);

    if (isMountedRef.current && isAudioInDOM()) {
      audioRef.current.volume = 0.15;
      audioRef.current.play().catch((error) => {
        console.error("오디오 재생에 실패했습니다.", error);
      });
    } else {
      console.log(
        "오디오 요소가 DOM에 존재하지 않거나 컴포넌트가 언마운트되었습니다.",
      );
    }

    if (audioRef.current) {
      audioRef.current.volume = 0.15;
      audioRef.current.play().catch((error) => {
        console.error("오디오 재생에 실패했습니다.", error);
      });
    }

    try {
      console.log("@@contentList => ", contentList);
      let stories = "";
      for (const content of contentList) {
        stories = stories + " " + content.page_content;
      }
      console.log("@@stories => ", stories);

      const data = {
        user_id: USER_ID,
        story_id: selectedBookId,
        stories,
      };

      const res = await callChatGPTAPIforTitle(data);
      console.log("[@title res]", res);

      // 🔹 공통 에러 코드 / 메시지 추출 (/story API는 errorCode / errorMessage 도 쓸 수 있음)
      const code =
        res?.errCode ||
        res?.errorCode ||
        res?.error?.errCode ||
        res?.error?.errorCode ||
        null;

      const msg =
        res?.errMsg ||
        res?.errorMessage ||
        res?.error?.errMsg ||
        res?.error?.errorMessage ||
        res?.error ||
        t("errors.makeTitleFailed");

      // ❌ 실패한 경우
      if (!res?.success) {
        // 🫘 마법콩 부족
        if (code === "Magicbean_ERR_00") {
          controlLoading(false);
          setErrorInfo({
            code,
            message: t("errors.magicbeanShortage"),
          });
          return;
        }

        // 그 외 에러
        alert(msg);
        setShowLoading(false);
        setshowCoverButton(false);
        return;
      }

      // ✅ 성공 케이스: 제목 파싱
      let title = res.data;
      if (typeof title === "string" && title.includes('"')) {
        title = title.replaceAll('"', "");
      }

      setTimeout(() => {
        setbookTitle(title);
        controlLoading(false);
        setshowCoverButton(true);
        setTitleMade(true);
      }, 3000);
    } catch (e) {
      console.error("[handleMakeTitle error]", e);
      controlLoading(false);
      alert(t("errors.makeTitleFailed"));
    }
  };

  const handleSetBackgroundImage = async () => {
    if (isCoverGeneratingRef.current) return;
    isCoverGeneratingRef.current = true;

    setLoadingTitle(t("loading.makeCover"));
    setLoadingFlag("title");
    controlLoading(true);

    try {
      await generateBookcover();
    } finally {
      isCoverGeneratingRef.current = false;
    }
  };

  // 폴링
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const pollBackgroundStatus = async (batchId, userId) => {
    while (true) {
      const res = await getFalaiBackgroundStatus({
        batch_id: batchId,
        user_id: userId,
      });

      console.log(
        "[FAL] status:",
        res?.data?.status,
        "done?",
        res?.data?.all_completed,
        "imgs:",
        res?.data?.images?.length,
      );

      if (!res?.success) throw new Error("배경 상태 조회 실패");

      const d = res.data ?? {};
      if (d.status === "failed") throw new Error("배경 생성 실패");

      if (d.all_completed === true && Array.isArray(d.images)) {
        console.log("✅ FAL 완료! images 개수:", d.images.length);
        return d.images;
      }
      await sleep(2000);
    }
  };

  const generateBookcover = async () => {
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    try {
      let stories = "";
      for (const content of contentList || []) {
        if (content?.page_content) stories += ` ${content.page_content}`;
      }

      const reqForPrompt = {
        user_id: USER_ID,
        story_id: selectedBookId,
        stories,
      };
      const res_chatgpt = await callChatGPTAPIforBookcover(reqForPrompt);
      if (!res_chatgpt?.success) {
        // 🫘 혹시 이 단계에서도 콩 에러가 올 수 있으면 여기서도 체크 가능
        const code =
          res_chatgpt?.errCode ||
          res_chatgpt?.errorCode ||
          res_chatgpt?.error?.errCode ||
          res_chatgpt?.error?.errorCode ||
          null;

        const msg =
          res_chatgpt?.errMsg ||
          res_chatgpt?.errorMessage ||
          res_chatgpt?.error?.errMsg ||
          res_chatgpt?.error?.errorMessage ||
          res_chatgpt?.error ||
          t("errors.coverPromptFailed");

        if (code === "Magicbean_ERR_00") {
          setShowLoading(false);
          setErrorInfo({
            code,
            message: t("errors.magicbeanShortage"),
          });
          return;
        }

        alert(msg);
        setShowLoading(false);
        return;
      }

      let promptObj;
      try {
        promptObj =
          typeof res_chatgpt.data === "object"
            ? res_chatgpt.data
            : JSON.parse(res_chatgpt.data);
      } catch (e) {
        console.error("[COVER] prompt JSON parse error:", e, res_chatgpt.data);
        alert(t("errors.coverPromptParseFailed"));
        setShowLoading(false);
        return;
      }

      const prompts = [
        {
          background_prompt: promptObj.background_prompt,
          character_prompt: promptObj.character_prompt,
          image_size: "landscape_4_3",
          num_images: 1,
        },
      ];

      const start = await callFalaiAPIforBackground(
        selectedBookId,
        prompts,
        USER_ID,
        "storybook_cover",
      );

      // 🔴 FAL 콩/에러 처리
      const code =
        start?.errCode ||
        start?.errorCode ||
        start?.error?.errCode ||
        start?.error?.errorCode ||
        null;

      const msg =
        start?.errMsg ||
        start?.errorMessage ||
        start?.error?.errMsg ||
        start?.error?.errorMessage ||
        start?.error ||
        t("errors.coverImageFailed");

      if (!start?.success) {
        if (code === "Magicbean_ERR_00") {
          setShowLoading(false);
          setErrorInfo({
            code,
            message: t("errors.magicbeanShortage"),
          });
          return;
        }

        console.error("[COVER] start error:", msg);
        alert(msg);
        setShowLoading(false);
        return;
      }

      const { batch_id } = start.data || {};
      console.log("[COVER] batch_id:", batch_id);
      if (!batch_id) {
        alert(t("errors.missingCoverBatchId"));
        setShowLoading(false);
        return;
      }

      const timeoutMs = 120000;
      const startedAt = Date.now();
      let images = null;

      while (true) {
        const statusRes = await getFalaiBackgroundStatus({
          batch_id,
          user_id: USER_ID,
        });

        console.log(
          "[COVER] status:",
          statusRes?.data?.status,
          "done?",
          statusRes?.data?.all_completed,
          "imgs:",
          statusRes?.data?.images?.length,
          "progress:",
          statusRes?.data?.progress,
        );

        if (!statusRes?.success) {
          throw new Error("표지 상태 조회 실패");
        }

        const d = statusRes.data || {};
        if (d.status === "failed") {
          throw new Error("표지 생성 실패");
        }

        if (d.all_completed === true && Array.isArray(d.images)) {
          images = d.images;
          console.log("✅ COVER 완료! images 개수:", images.length);
          break;
        }

        if (Date.now() - startedAt > timeoutMs) {
          throw new Error("표지 생성 대기 시간 초과");
        }

        await sleep(2000);
      }

      const coverUrl = images?.[0]?.[0]?.url || "";
      console.log("[COVER] 최종 URL:", coverUrl);

      if (!coverUrl) {
        throw new Error("표지 URL이 비어 있습니다.");
      }

      setBackgroundImage(coverUrl);
      controlLoading(false);

      if (audioRef.current) {
        try {
          await audioRef.current.play();
        } catch (e) {
          console.warn("오디오 재생 실패:", e);
        }
      }

      setCoverMade(true);
    } catch (e) {
      console.error("표지 생성 에러:", e);
      setShowLoading(false);
      alert(t("errors.coverGenerationFailed"));
    }
  };

  const handleCompletedBtn = async () => {
    setShowNameModal(true);
  };

  const handleSaveFinalBook = async () => {
    if (isSavingRef.current) return;
    if (!studentName.trim()) {
      alert(t("alerts.enterName"));
      return;
    }

    isSavingRef.current = true;
    setIsSaving(true);
    setIsButtonEnabled(false);
    setShowNameModal(false);

    try {
      const fullTitle = `${bookTitle} - ${studentName.trim()}`;
      const body = {
        story_id: selectedBookId,
        title: fullTitle,
        bookcover: backgroundImage,
        creator: USER_ID,
        page_count: contentList.length,
        contents_json: contentList,
        branchNum: branchNum,
        job_ids: [jobId],
      };

      const res = await saveCompletedBook(body);

      if (res?.success === false) {
        throw new Error(res?.errorMessage || res?.errMsg || t("errors.missingSavedBookId"));
      }

      const row = Array.isArray(res)
        ? res[0]
        : Array.isArray(res?.data)
          ? res.data[0]
          : (res?.data ?? res);

      const newBookId = row?.book_id ?? row?.id;

      if (!newBookId) {
        throw new Error(t("errors.missingSavedBookId"));
      }

      setSavedBookId(newBookId);
      setShowCompleteModal(true);
    } catch (e) {
      console.error("[handleSaveFinalBook] 저장 실패:", e);
      setIsButtonEnabled(true);
      alert(e.message || t("errors.missingSavedBookId"));
    } finally {
      isSavingRef.current = false;
      setIsSaving(false);
    }
  };

  // test
  console.log("savedBookId---->>>", savedBookId);

  return (
    <section
      className="final-modal-section"
      style={
        backgroundImage.length === 0
          ? { backgroundImage: backgroundImage }
          : { backgroundImage: `url(${backgroundImage})` }
      }
    >
      <audio ref={audioRef} src="/audio/twinkle-storybook-final.mp3" />
      {isSaving && createPortal(
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 2147483647,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "auto",
          cursor: "wait",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ color: "#fff", textAlign: "center" }}>
          <p>{t("status.savingStory")}</p>
        </div>
      </div>,
      document.body
    )}
      {(isContentVisible || !isButtonEnabled) && (
        <>
          <div className="loader"></div>
          {!isButtonEnabled && backgroundImage && bookTitle && (
            <p className="sub-title">{t("status.savingStory")}</p>
          )}
        </>
      )}
      {/* 책 제목이 완성되면 특정 클래스명 추가하기 */}
      {bookTitle && !backgroundImage && (
        <p className="title-completed-notice">{t("status.titleCompleted")}</p>
      )}
      <h2 className={`final-title ${bookTitle ? "sucess" : ""}`}>
        {/* {bookTitle || '제목을 만들어주세요'} */}
        {bookTitle
          ? studentName
            ? `${bookTitle} - ${studentName}`
            : bookTitle
          : t("status.needTitle")}
      </h2>

      {/* 제목이 설정되었고, 표지 이미지가 아직 없을 때 "표지를 만들어주세요" 텍스트와 버튼을 보여줌 */}
      {bookTitle && !backgroundImage && (
        <p className="cover-instruction-notice blink">
          {t("status.needCover")}
        </p>
      )}
      <div
        className={`container-flex ${titleMade && coverMade ? "reverse" : ""}`}
      >
        <div className="choose-btn-container">
          <button
            className="make-buttons make-title-button"
            onClick={() => {
              handleMakeTitle();
            }}
          >
            {bookTitle ? t("actions.remakeTitle") : t("actions.makeTitle")}
          </button>
          {showCoverButton && (
            <button
              className="make-buttons make-cover-button"
              onClick={() => {
                handleSetBackgroundImage();
              }}
            >
              {backgroundImage
                ? t("actions.remakeCover")
                : t("actions.makeCover")}
            </button>
          )}
        </div>
        <button
          className={`complete ${isButtonEnabled ? "on" : ""}`}
          disabled={!isButtonEnabled}
          onClick={handleCompletedBtn}
        >
          {t("actions.saveStory")}
        </button>
      </div>
      <div className="go-back" onClick={handleGoBack}>
        {t("actions.goBack")}
      </div>

      {showLoading && (
        <Loading
          title={loadingTitle}
          end={generateEnd}
          flag={loadingFlag}
          onEnd={() => setShowLoading(false)}
        />
      )}
      {showCompleteModal && (
        <CompleteModal
          contents_json={contentList}
          title={bookTitle}
          backgroundImage={backgroundImage}
          bookId={savedBookId}
        />
      )}
      {showNameModal && (
        <div className="name-modal-overlay">
          <div className="name-modal">
            <h3>{t("nameModal.title")}</h3>
            <input
              type="text"
              placeholder={t("nameModal.placeholder")}
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
            />
            <div className="name-modal-buttons">
              <button onClick={() => setShowNameModal(false)}>
                {t("actions.cancel")}
              </button>
              <button onClick={handleSaveFinalBook}>{t("actions.save")}</button>
            </div>
          </div>
        </div>
      )}
      {errorInfo && (
        <ErrorModal
          error_message={errorInfo.message}
          onClose={() => setErrorInfo(null)}
        />
      )}
    </section>
  );
};

export default FinalModal;
